module.exports = __webpack_public_path__ + "img/fill-1.8e053898.svg";